import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6061e347"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Vissza")
const _hoisted_2 = { class: "segment-container" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Név alapján")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Hely alapján")
const _hoisted_5 = {
  key: 2,
  class: "bottom-absolute"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "ion-margin-bottom" }, [
  /*#__PURE__*/_createElementVNode("strong", null, " Nincs találat ")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "ion-text-center" }, [
  /*#__PURE__*/_createTextVNode("Próbáld meg máshogy. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Név alapján vagy hely alapján keresel?")
], -1))
const _hoisted_8 = {
  key: 3,
  class: "bottom-absolute"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "ion-margin-bottom" }, [
  /*#__PURE__*/_createElementVNode("strong", null, " Hova szeretnél menni? ")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "ion-text-center" }, [
  /*#__PURE__*/_createTextVNode("Csak kezdd el írni. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Válaszd ki, hogy név vagy hely alapján keresel.")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_searchbar = _resolveComponent("ion-searchbar")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_segment_button = _resolveComponent("ion-segment-button")!
  const _component_ion_segment = _resolveComponent("ion-segment")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_item_divider = _resolveComponent("ion-item-divider")!
  const _component_ion_item_group = _resolveComponent("ion-item-group")!
  const _component_ion_img = _resolveComponent("ion-img")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_modal = _resolveComponent("ion-modal")!

  return (_openBlock(), _createBlock(_component_ion_modal, {
    "is-open": _ctx.trendingSearchModal.open,
    "swipe-to-close": true,
    "show-backdrop": true,
    "presenting-element": _ctx.$root.$refs.mainRouterOutlet.$el,
    onDidDismiss: _ctx.dismiss
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, { class: "toolbar" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_searchbar, {
                class: "f",
                animated: "",
                debounce: "100",
                modelValue: _ctx.q,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.q) = $event)),
                placeholder: "Keresés",
                onIonChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchInput($event.detail.value)))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_ion_buttons, {
                slot: "end",
                class: "l"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, { onClick: _ctx.dismiss }, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { class: "relative" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_ion_segment, {
              modelValue: _ctx.slider,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.slider) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_segment_button, { value: "name" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => [
                        _hoisted_3
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_segment_button, { value: "location" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => [
                        _hoisted_4
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          (_ctx.slider == 'name')
            ? (_openBlock(), _createBlock(_component_ion_list, {
                key: 0,
                class: "clear-list"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.placeSearchByName, (place) => {
                    return (_openBlock(), _createBlock(_component_ion_item, {
                      key: place.id
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          onClick: ($event: any) => (_ctx.open(place))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(place.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.slider == 'location')
            ? (_openBlock(), _createBlock(_component_ion_list, {
                key: 1,
                class: "clear-list"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ptExact, (place) => {
                    return (_openBlock(), _createBlock(_component_ion_item, {
                      key: place.id
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          onClick: ($event: any) => (_ctx.open(place))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(place.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ptStartsWith.keys(), (k) => {
                    return (_openBlock(), _createBlock(_component_ion_item_group, { key: k }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_item_divider, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, {
                              onClick: ($event: any) => (_ctx.search(k))
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("strong", null, _toDisplayString(k), 1)
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]),
                          _: 2
                        }, 1024),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ptStartsWith.get(k), (place) => {
                          return (_openBlock(), _createBlock(_component_ion_item, {
                            key: place.id
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, {
                                onClick: ($event: any) => (_ctx.open(place))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(place.name), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 2
                    }, 1024))
                  }), 128)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ptIncludes.keys(), (k) => {
                    return (_openBlock(), _createBlock(_component_ion_item_group, { key: k }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_item_divider, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => [
                                _createElementVNode("strong", null, _toDisplayString(k), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ptIncludes.get(k), (place) => {
                          return (_openBlock(), _createBlock(_component_ion_item, {
                            key: place.id
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, {
                                onClick: ($event: any) => (_ctx.open(place))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(place.name), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 2
                    }, 1024))
                  }), 128)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ptReverseIncludes.keys(), (k) => {
                    return (_openBlock(), _createBlock(_component_ion_item_group, { key: k }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_item_divider, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => [
                                _createElementVNode("strong", null, _toDisplayString(k), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ptReverseIncludes.get(k), (place) => {
                          return (_openBlock(), _createBlock(_component_ion_item, {
                            key: place.id
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, {
                                onClick: ($event: any) => (_ctx.open(place))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(place.name), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.q.length != 0 && _ctx.noResults())
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _hoisted_6,
                _hoisted_7,
                _createVNode(_component_ion_img, {
                  src: './assets/image/no_results.png',
                  class: "end-image"
                }, null, 8, ["src"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.q.length == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _hoisted_9,
                _hoisted_10,
                _createVNode(_component_ion_img, {
                  src: './assets/image/start_searching.png',
                  class: "end-image"
                }, null, 8, ["src"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["is-open", "presenting-element", "onDidDismiss"]))
}